import React, {useEffect, useMemo, useRef, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CaptionedField from "../../../UIComponents/captionedField";
import ReportHeader from "../reportHeader";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import PrintIcon from "@material-ui/icons/Print";
import DeleteIcon from '@material-ui/icons/Delete';
import _ from 'lodash'
import moment from 'moment'
import {Divider} from "@material-ui/core";
import {TextField, useDataProvider, useQueryWithStore,DateField,NumberField,  FunctionField, usePermissions } from "react-admin";
import MyDatagrid from "../../accountsGrid";
import MultiCurrencyField from "../../../UIComponents/multiCurrencyField";
import MultiCurrency from "../../multiCurrency";
import {FormattedNumber} from "react-intl";
import RowNumberField from "../../../UIComponents/RowNumberField";
import ReviewRemarkDialog from '../../dialogs/ReviewRemarkDialog';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import WithConfirm from "../../../UIComponents/withConfirm";
import Popover from '@material-ui/core/Popover';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import { FormControl, InputLabel } from '@material-ui/core';
import { fi } from 'date-fns/locale';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const PayrollSummeryReport = ({payrollRun,logo,stamp,site,employmentType,department, filteredPayrolls, emps, sort,handelSort, onReview, getFilteredPayrolls, filters, costCenters}) => {
    const componentRef = useRef();
    const dataProvider = useDataProvider();
    const permissions = usePermissions();
    const currentUser = localStorage.getItem('user');
    const canReview = permissions.permissions && (permissions.permissions.includes('Reviewer')||permissions.permissions.includes('FinalReviewer')||permissions.permissions.includes('Manager'));
    const isManager = permissions.permissions && permissions.permissions.includes('Manager');
    // const currentUserRole = permissions.permissions && permissions.permissions.includes('Reviewer') ? 'reviewer' : '';
    const [payroll1, setPayroll1] = useState();
    const [filteredPayroll1, setFilteredPayroll1] = useState();
    const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
    // const [reviewRemark, setReviewRemark] = useState(payrollRun && payrollRun.remarks ? payrollRun.remarks[0] : null);
    // const [variance, setVariance] = useState();
    const [sectionVisibility, setSectionVisibility] = useState({
        earningsDeductions: true,
        serviceCharge: true,
        totals: true,
        prevTotals: true,
        newHires: true,
        endedEmployments: true,
        thisMonthEnded: true,
        salaryAdjustment: true,
        overtime: true,
        allowanceChange: true,
        absentDeduction: true,
        proratedSalaryChange: true,
        serviceChargeDetails: true,
    });
    const [showPrevAbsentDeductions, setShowPrevAbsentDeductions] = useState(false);
    const [showPrevOvertime, setShowPrevOvertime] = useState(false);
    const toggleSection = (section) => {
        setSectionVisibility(prev => ({ ...prev, [section]: !prev[section] }));
    };
    // Filter payroll1 with current filters whenever payroll1 or filters change
    useEffect(() => {
        //console.log({filters})
        if (payroll1 && payroll1.payrolls && getFilteredPayrolls && costCenters) {
            setFilteredPayroll1(getFilteredPayrolls(payroll1.payrolls, _.omit(filters, ['emailStatus']), costCenters));
        } else {
            setFilteredPayroll1(undefined);
        }
    }, [payroll1, getFilteredPayrolls, filters, costCenters]);
    // Use filteredPayroll1 for variance and all comparisons
    const variance = useMemo(() => {
        if (!payrollRun || !payroll1) return null;
        // Use unfiltered for new/ended, filtered for salaryChange
        return getVariance(
            payrollRun.payrolls || [],
            payroll1.payrolls || [],
            filteredPayrolls || [],
            filteredPayroll1 || []
        );
    }, [payrollRun, payroll1, filteredPayrolls, filteredPayroll1]);
    const absentDeductions = useMemo(() => {
        if (!variance) return null;
        const filtered = showPrevAbsentDeductions
            ? variance.salaryChange.filter(e => e.diffBasicAbsentDeduction !== 0 || e.basicAbsentDeduction !== 0)
            : variance.salaryChange.filter(e => e.basicAbsentDeduction !== 0);
        return _.orderBy(filtered, ['basicAbsentDeduction'], ['desc']).map((e, index) => ({...e, sn: index + 1}));
    }, [variance, showPrevAbsentDeductions])
    const overtimes = useMemo(() =>variance&&_.orderBy(variance.salaryChange.filter(e=>e.diffOT!==0||e.overtimeTotal!==0),['overtimeTotal'],['desc']).map((e,index)=>({...e,sn:index+1})),[variance])
    const newHires = useMemo(() =>variance&&_.orderBy(variance.newEmps,['fullBasicSalary'],['desc']).map((e,index)=>({...e,sn:index+1})),[variance])

    const currentOvertimes = useMemo(() => _.orderBy(filteredPayrolls.filter(p=>p.overtimeTotal),['overtimeTotal'],['desc']).map((p,index) => {

            return {
                ...p,
                sn: index+1,
            }

    }), [filteredPayrolls]);

    const [serviceChargeSort, setServiceChargeSort] = useState({field: 'serviceCharge', order: 'ASC'});
    const handleServiceChargeSort = (field) => {
        setServiceChargeSort(prev => ({
            field,
            order: prev.field === field && prev.order === 'ASC' ? 'DESC' : 'ASC'
        }));
    };
    const serviceChargeDetails = useMemo(() => {
        const filtered = filteredPayrolls.filter(p => p.serviceCharge || p.serviceChargeDeduction);
        return _.orderBy(filtered, [serviceChargeSort.field], [serviceChargeSort.order.toLowerCase()]).map((p, index) => ({
            ...p,
            sn: index + 1,
        }));
    }, [filteredPayrolls, serviceChargeSort]);

    function getTotals(payrolls) {
       if (payrolls && payrolls.length) {
           return {
               basicSalary: _.sumBy(payrolls, 'basicSalary'),
               additionalFixedEarnings: _.sumBy(payrolls, 'additionalFixedEarnings'),
               bonusesTotal: _.sumBy(payrolls, 'bonusesTotal'),
               overtimeTotal: _.sumBy(payrolls, 'overtimeTotal'),
           };
       }
       // Always return an object with zeroes
       return {
           basicSalary: 0,
           additionalFixedEarnings: 0,
           bonusesTotal: 0,
           overtimeTotal: 0,
       };
   }

    const totalPayroll = useMemo(() => getTotals(filteredPayrolls), [filteredPayrolls]);
    const totalPrevPayroll = useMemo(() => getTotals(filteredPayroll1), [filteredPayroll1]);

    function getVariance(unfilteredCurrent, unfilteredPrev, filteredCurrent, filteredPrev) {
        if(unfilteredCurrent && unfilteredCurrent.length && unfilteredPrev && unfilteredPrev.length) {
            const p1EmpIds = unfilteredCurrent.map(p=>p.employeeId)
            const p2EmpIds = unfilteredPrev.map(p=>p.employeeId)
            const newEmps = unfilteredCurrent.filter(p=>p.employeeId&&!p2EmpIds.includes(p.employeeId))
            const endEmps = unfilteredPrev.filter(p=>p.employeeId&&!p1EmpIds.includes(p.employeeId))
            // thisMonthEndEmps can still use filteredCurrent if it is filter-dependent
            const thisMonthEndEmps = filteredCurrent.filter(p=>p.employee&&p.employee.contractEndDate&&moment(p.employee.contractEndDate)>=moment(payrollRun.periodStart)&&moment(p.employee.contractEndDate)<=moment(payrollRun.periodEnd))
            // For salaryChange, use filteredCurrent/filteredPrev
            const p2LookUp = {}
            for(let p of filteredPrev) {
                p2LookUp[p.employeeId] =p
            }
           // console.log({p2LookUp,filteredPrev})
            const salaryChange = filteredCurrent.map(p=>{
                const px = p2LookUp[p.employeeId]
                console.log({p,px})
                if(px && px.cash!==p.cash) {
                    console.log({p,px})
                    p.prevPayroll = px;
                    // --- CURRENCY ADJUSTMENT LOGIC START ---
                    var ignoreDueToCurrency = false;
                    var prevFullBasic = px.fullBasicSalary;
                    var prevBasic = px.basicSalary;
                    if (p.basicCurrency && p.basicCurrency.toLowerCase() !== 'etb') {
                        var currRate = p.currencyRate;
                        var prevRate = px.currencyRate;
                        if (currRate !== prevRate) {
                            var prevFullBasicAdj = prevFullBasic * (currRate / prevRate);
                            var prevBasicAdj = prevBasic * (currRate / prevRate);
                            if (Math.abs(p.fullBasicSalary - prevFullBasicAdj) < 1) {
                                ignoreDueToCurrency = true;
                            }
                            prevFullBasic = prevFullBasicAdj;
                            prevBasic = prevBasicAdj;
                        }
                    }
                    if (!ignoreDueToCurrency) {
                        p.diffFullBasic = p.fullBasicSalary - prevFullBasic;
                        p.diffBasic = p.basicSalary - prevBasic - (p.fullBasicSalary - prevFullBasic);
                    } else {
                        p.diffFullBasic = 0;
                        p.diffBasic = 0;
                    }
                    // --- CURRENCY ADJUSTMENT LOGIC END ---
                    p.diffOT = p.overtimeTotal - px.overtimeTotal;
                    p.diffAdditionalEarnings = p.additionalFixedEarnings - px.additionalFixedEarnings;
                    p.diffBasicAbsentDeduction = p.basicAbsentDeduction - px.basicAbsentDeduction;
                }
                return p;
            }).filter(p=>p.prevPayroll)
           // console.log({salaryChange})
            return {
                newEmps,
                endEmps,
                thisMonthEndEmps,
                salaryChange
            }
        }
        return null
    }

    const loadPayrollRun = (id)=> {
        // const { data } = useQueryWithStore({
        //     type: 'getOne',
        //     resource: 'payrollRuns',
        //     payload: {id,expand:'payrolls'}
        // });
        dataProvider.getOne('payrollRuns', { id,expand:`payrolls($orderby=fullName; $expand=payrollFixedEarnings ,payrollFixedExpenses, payrollDeductions,payrollFixedDeductions,bonuses,overtimes($expand=type))` })
            .then(({ data }) => {

                    data.payrolls.map(p=>{
                        p.employee = (emps && emps.find(e=>e.id === p.employeeId)) || {}
                        p.currencyRate = p.basicCurrency ? data.usedCurrencyRates[p.basicCurrency.toLowerCase()] : 1
                    })

                    setPayroll1(data)
                    // setVariance(getVariance(filteredPayrolls,data.payrolls))


            })

    };
    // const getNewHires = (payrolls) => {
    //     return  payrolls.filter(p=>p.employee.startDate)
    // }
    const { loaded, error, data: payrollRuns } = useQueryWithStore({
        type: 'getList',
        resource: 'payrollRuns',
        payload: {
            filter:  {filter: `(Status eq 'Approved' or Status eq 'Reviewed' or Status eq 'ReadyForApproval') and PayrollDate lt ${moment(payrollRun.payrollDate).toISOString()}`} ,
            pagination: {},
            sort: { field: 'payrollDate', order: 'DESC' }
        }
    });


    // const { data: payrollRunsToMatch } = useQueryWithStore({
    //     type: 'getList',
    //     resource: 'payrollRuns',
    //     payload: {
    //         filter:  {filter: `(Status eq 'Reviewed' or Status eq 'ReadyForApproval') and PayrollDate eq ${moment(payrollRun.payrollDate).toISOString()}`, expand:'payrolls'} ,
    //         pagination: {},
    //         sort: { field: 'payrollDate', order: 'DESC' }
    //     }
    // });

    // Track selected payroll1 id
    const [selectedPayroll1Id, setSelectedPayroll1Id] = useState();
    // When payrollRuns load, set default selection to latest
    useEffect(() => {
        if(payrollRuns&&payrollRuns.length) {
            setSelectedPayroll1Id(payrollRuns[0].id);
            loadPayrollRun(payrollRuns[0].id);
        }
    }, [payrollRuns]);
    // When user selects a payrollRun from dropdown
    const handlePayroll1Change = (event) => {
        setSelectedPayroll1Id(event.target.value);
        loadPayrollRun(event.target.value);
    };

    const handleMarkReviewed = () => {
        setReviewDialogOpen(true);
    };
    const handleReviewSubmit = (remarkObj) => {
        // setReviewRemark(remarkObj);
        setReviewDialogOpen(false);
        if (onReview) {
            // Add a unique ID to the new remark to prevent duplicates
            const newRemark = { ...remarkObj, _id: moment().unix().toString()            };
            const updatedRemarks = payrollRun.remarks ? [...payrollRun.remarks, newRemark] : [newRemark];
            // Pass the `reviewRemark` for the backend save, and the full `remarks` array for the UI update.
            onReview({ ...payrollRun, status: 'Reviewed', remarks: updatedRemarks, reviewRemark: newRemark });
        }
    };

    const handleDeleteRemark = (idToDelete) => {
        console.log(idToDelete)
        if (onReview) {
            const updatedRemarks = payrollRun.remarks.filter(r => r._id !== idToDelete);
            // Call onReview without reviewRemark to signal a state update, not a new submission
            onReview({ ...payrollRun, remarks: updatedRemarks });
        }
    };

    return (
        <div>
            {/* Payroll1 selection dropdown */}
            <Grid container alignItems="center" spacing={2} style={{marginBottom: 16}}>
                <Grid item>
                    <Typography variant="subtitle1">Compare Against:</Typography>
                </Grid>
                <Grid item>
                    <Select
                        value={selectedPayroll1Id || ''}
                        onChange={handlePayroll1Change}
                        displayEmpty
                        style={{ minWidth: 320 }}
                        disabled={!payrollRuns || !payrollRuns.length}
                    >
                        {payrollRuns && payrollRuns.map(run => (
                            <MenuItem key={run.id} value={run.id}>
                                {moment(run.payrollDate).format('MMMM YYYY')} | Status: {run.status} | Net: {run.cash.toFixed(2)} | Run by: {run.createdBy} | Run Date: {moment(run.createdAt || run.runDate).format('YYYY-MM-DD')}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            {/* Show review status and remark if present */}
            {payrollRun.remarks&&payrollRun.remarks.map((reviewRemark, index) => {
                const remarkId = reviewRemark._id
                return (
                <Grid key={remarkId} container direction="column" spacing={1} style={{marginBottom: 8, border: '1px solid #eee', padding: 8, position: 'relative'}}>
                    {canReview && (isManager || reviewRemark.user === currentUser) && (
                        <WithConfirm
                            title="Delete Review Remark?"
                            content="Are you sure you want to delete this review remark? This action cannot be undone."
                            onConfirm={() => handleDeleteRemark(remarkId)}
                        >
                            <IconButton 
                                size="small" 
                                style={{ position: 'absolute', top: 4, right: 4 }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </WithConfirm>
                    )}
                    <Grid item>
                        <Typography color="primary"><strong>Status:</strong> {reviewRemark.type || 'Reviewed'}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2"><strong>Reviewer:</strong> {reviewRemark.user}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2"><strong>Date:</strong> {moment(reviewRemark.date).format('YYYY-MM-DD HH:mm')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2"><strong>Remark:</strong> {reviewRemark.remarkText}</Typography>
                    </Grid>
                    {reviewRemark.checkedEmployeeIds && reviewRemark.checkedEmployeeIds.length > 0 &&
                        <Grid item>
                            <Typography variant="body2"><strong>Payrolls Checked:</strong> {reviewRemark.checkedEmployeeIds.length}</Typography>
                        </Grid>
                    }
                    {reviewRemark.payrollNotes && reviewRemark.payrollNotes.length > 0 &&
                        <Grid item>
                            <Typography variant="body2"><strong>Payrolls with Notes:</strong> {reviewRemark.payrollNotes.length}</Typography>
                        </Grid>
                    }
                </Grid>
            )})}
            {/* Reviewer button only for reviewer role and if not already reviewed/approved */}
            {canReview  && payrollRun.status !== 'Approved' && (
                <Button disabled={payrollRun.status === 'ReadyForApproval'} color="primary" variant="contained" style={{marginBottom: 12}} onClick={handleMarkReviewed}>
                    Add Review
                </Button>
            )}
            {canReview && <ReviewRemarkDialog
                open={reviewDialogOpen}
                onClose={() => setReviewDialogOpen(false)}
                onSubmit={handleReviewSubmit}
                user={currentUser}
                showInput={true}
                payrollRun={payrollRun}
                payrollRun1={payroll1}
            />}
            <ReactToPrint
                //onBeforePrint={()=>setScrollable("none")}
                trigger={() => <Button  variant="outlined"  color="primary"  startIcon={<PrintIcon/>}  >Print</Button>}
                content={() => componentRef.current}
                pageStyle={""}
            />
            {/* Ready For Approval Button */}
            {permissions.permissions && permissions.permissions.includes('FinalReviewer')&& (
                <WithConfirm
                    title="Mark as Ready For Approval?"
                    content="Are you sure you want to mark this payroll as Ready For Approval? This action will change the status."
                    onConfirm={function() { if (onReview) { onReview({ ...payrollRun, status: 'ReadyForApproval', checkedBy: currentUser  }); } }}
                >
                    <Button
                        variant="contained"
                        disabled={payrollRun.status !== 'Reviewed'}
                        color="secondary"
                        style={{ marginLeft: 8, marginBottom: 12 }}
                    >
                        Mark as Ready For Approval
                    </Button>
                </WithConfirm>
            )}
            <div ref={componentRef}>
            <ReportHeader logo={logo} site={site} employmentType={employmentType} department={department} payrollRun={payrollRun} title="Payroll Summery Report"/>
                <CaptionedField value={payrollRun.cash} label='Net Pay' />
         
                <Divider/>
            {/* Earnings & Deductions */}
            <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.earningsDeductions ? '' : 'no-print'}>
                <Grid item className="no-print">
                    <IconButton size="small" onClick={() => toggleSection('earningsDeductions')}>
                        {sectionVisibility.earningsDeductions ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                    </IconButton>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle2">Earnings & Deductions</Typography>
                </Grid>
            </Grid>
            {sectionVisibility.earningsDeductions && <Grid container spacing={10}>
                <Grid item>
                    <Grid container direction="column">

                            <Grid item>
                                Earning
                            </Grid>

                        <Grid item>
                            <CaptionedField value={totalPayroll.basicSalary} label='Basic Salary'/>
                            {variance&&<ul>
                                <li>{payroll1&&moment(payroll1.payrollDate).format('MMMM YYYY')} Basic Salary  <strong><FormattedNumber maximumFractionDigits={2}   value= {totalPrevPayroll.basicSalary}/></strong></li>
                                <li><strong>{variance.newEmps.length} New </strong> Hires <span style={{fontSize:'smaller'}}>*Full Salary <FormattedNumber maximumFractionDigits={2}   value= {_.sumBy(variance.newEmps,'fullBasicSalary')}/></span>  This month salary  +<FormattedNumber maximumFractionDigits={2}   value= {_.sumBy(variance.newEmps,'basicSalary')}/>    </li>
                                <li><strong>{variance.endEmps.length} End </strong> Employments -<FormattedNumber maximumFractionDigits={2}   value= {_.sumBy(variance.endEmps,'basicSalary')}/> </li>
                                <li>{variance.salaryChange.filter(e=>e.diffFullBasic!==0).length} Salary Adjustment +<FormattedNumber maximumFractionDigits={2}   value= {_.sumBy(variance.salaryChange,'diffFullBasic')}/> </li>
                                <li>{variance.salaryChange.filter(e=>e.diffBasic!==0).length} Salary Prorate Change +<FormattedNumber maximumFractionDigits={2}   value= {_.sumBy(variance.salaryChange,'diffBasic')}/> </li>
                            </ul>}
                        </Grid>
                        <Grid item>
                            <CaptionedField value={totalPayroll.additionalFixedEarnings} label='Allowances' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={totalPayroll.bonusesTotal} label='This Month Extra Earnings' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={totalPayroll.overtimeTotal} label='Total Overtime' />
                        </Grid>
                          <Divider/>



                    </Grid>
               </Grid>
                <Grid item>
                    <Grid container direction="column">
                        <Grid item>
                            Deduction
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(filteredPayrolls,'empPension')} label='Pension Employee' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(filteredPayrolls,'costSharing')} label='Cost Sharing' />
                        </Grid>

                        <Grid item>
                            <CaptionedField value={_.sumBy(filteredPayrolls,'fixedDeductionsTotals')-_.sumBy(filteredPayrolls,'empPension')-_.sumBy(filteredPayrolls,'costSharing')} label='Other Fixed Payroll Deductions' />
                        </Grid>
                        <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'absenceDeduction')} label='Absence Deductions' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(filteredPayrolls,'payrollDeductionTotal')} label='This Month Payroll Deductions' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(filteredPayrolls,'incomeTax')} label='Income Tax' />
                        </Grid>

                        {/*<Grid item>*/}
                        {/*    <CaptionedField value={_.sumBy(filteredPayrolls,'companyPension')} label='Pension Company' />*/}
                        {/*</Grid>*/}
                        {/*<Grid item>*/}
                        {/*    <CaptionedField value={_.sumBy(filteredPayrolls,'totalPension')} label='Total Pension' />*/}
                        {/*</Grid>*/}
                    </Grid>
                </Grid>


            </Grid>}
            {/* Service Charge */}
            {filteredPayrolls && filteredPayrolls.some(p => p.serviceCharge || p.serviceChargeDeduction) && <>
            <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.serviceCharge ? '' : 'no-print'}>
                <Grid item className="no-print">
                    <IconButton size="small" onClick={() => toggleSection('serviceCharge')}>
                        {sectionVisibility.serviceCharge ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                    </IconButton>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle2">Service Charge</Typography>
                </Grid>
            </Grid>
            {sectionVisibility.serviceCharge && <Grid container spacing={10}>
                <Grid item>
                    <CaptionedField value={_.sumBy(filteredPayrolls, 'serviceDays')} label='Total Service Days' />
                </Grid>
                <Grid item>
                    <CaptionedField value={_.sumBy(filteredPayrolls, 'serviceCharge')} label='Total Service Charge' />
                </Grid>
                <Grid item>
                    <CaptionedField value={_.sumBy(filteredPayrolls, 'serviceChargeDeduction')} label='Total Service Charge Deduction' />
                </Grid>
            </Grid>}
            </>}
            {/* Totals */}
            <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.totals ? '' : 'no-print'}>
                <Grid item className="no-print">
                    <IconButton size="small" onClick={() => toggleSection('totals')}>
                        {sectionVisibility.totals ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                    </IconButton>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle2">Current Period Totals</Typography>
                </Grid>
            </Grid>
            {sectionVisibility.totals && <Grid container spacing={10}>
                    <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'totalIncome')} label='Total Employment Income' />
                    </Grid>
                    <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'totalDeduction')} label='Total Deduction' />
                    </Grid>
                    <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'netPay')} label='Net' />
                    </Grid>
                    <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'payrollDeductionTotalCash')} label='Settlements' />
                    </Grid>
                    <Grid item>
                        <CaptionedField value={_.sumBy(filteredPayrolls,'cash')} label='Net Pay' />
                    </Grid>
                    <Grid item></Grid>
                </Grid>}
                {payroll1&&payroll1.id&&<div>
                    {/* Previous Period Totals */}
                    <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.prevTotals ? '' : 'no-print'}>
                        <Grid item className="no-print">
                            <IconButton size="small" onClick={() => toggleSection('prevTotals')}>
                                {sectionVisibility.prevTotals ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2">{moment(payroll1.payrollDate).format('MMMM YYYY')} Totals</Typography>
                        </Grid>
                    </Grid>
                    {sectionVisibility.prevTotals && <div>
                    {moment(payroll1.payrollDate).format('MMMM YYYY')}
                    <Grid container spacing={10}>
                        <Grid item>
                            <CaptionedField value={_.sumBy(payroll1.payrolls,'totalIncome')} label='Total Employment Income' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(payroll1.payrolls,'totalDeduction')} label='Total Deduction' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(payroll1.payrolls,'netPay')} label='Net' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(payroll1.payrolls,'payrollDeductionTotalCash')} label='Settlements' />
                        </Grid>
                        <Grid item>
                            <CaptionedField value={_.sumBy(payroll1.payrolls,'cash')} label='Net Pay' />
                        </Grid>
                        <Grid item></Grid>
                    </Grid>
                    </div>}
                    {variance&& <div>
                        {/*{variance.newEmps.map(p=><div>*/}
                        {/*    {p.fullName} {p.employee&&p.employee.startDate}*/}
                        {/*</div>)}*/}
                        {/* New Hires */}
                        <div className={`page-break${sectionVisibility.newHires ? '' : ' no-print'}`}></div>
                        <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.newHires ? '' : 'no-print'}>
                            <Grid item className="no-print">
                                <IconButton size="small" onClick={() => toggleSection('newHires')}>
                                    {sectionVisibility.newHires ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5">New Hires</Typography>
                            </Grid>
                        </Grid>
                        {sectionVisibility.newHires && <Grid container spacing={10}>
                            <Grid item>

                                <MyDatagrid fullHeight checkField={false}
                                            summeryFields={['fullBasicSalary', 'basicSalary', 'cash']} data={newHires}
                                            ids={newHires.map((e, index) => index)}
                                            currentSort={{field: 'fullBasicSalary', order: 'DESC'}}
                                            setSort={handelSort}>
                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <TextField label="Bank Account" source="bankAccountNumber"/>
                                    <MultiCurrencyField source={"fullBasicSalary"}/>
                                    <DateField label={"Starting From"} source={"employee.startDate"}/>
                                    <MultiCurrencyField label={"This Month Salary"} source={"basicSalary"}/>
                                    <MultiCurrencyField label={"Net Pay"} source={"cash"}/>
                                </MyDatagrid>


                            </Grid>

                        </Grid>}
                        {/* Ended Employments */}
                        <div className={`page-break${sectionVisibility.endedEmployments ? '' : ' no-print'}`}></div>
                        <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.endedEmployments ? '' : 'no-print'}>
                            <Grid item className="no-print">
                                <IconButton size="small" onClick={() => toggleSection('endedEmployments')}>
                                    {sectionVisibility.endedEmployments ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5">Ended Employments {moment(payroll1.payrollDate).format('MMMM YYYY')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={10}>

                            <Grid item>
                                {sectionVisibility.endedEmployments && <MyDatagrid fullHeight checkField={false}
                                            summeryFields={['fullBasicSalary', 'basicSalary', 'cash']}
                                            data={variance.endEmps.map((e, index) => ({...e, sn: index + 1}))}
                                            ids={variance.endEmps.map((e, index) => index)} currentSort={sort}
                                            setSort={handelSort}>
                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <DateField label={"Ended On"} source={"employee.contractEndDate"}/>
                                    <MultiCurrencyField source={"basicSalary"}/>
                                    <MultiCurrencyField label={"Net Pay"} source={"cash"}/>
                                </MyDatagrid>}
                            </Grid>
                            <Grid item>
                                <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.thisMonthEnded ? '' : 'no-print'}>
                                    <Grid item className="no-print">
                                        <IconButton size="small" onClick={() => toggleSection('thisMonthEnded')}>
                                            {sectionVisibility.thisMonthEnded ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h5">Ended Employments {moment(payrollRun.payrollDate).format('MMMM YYYY')}</Typography>
                                    </Grid>
                                </Grid>
                                {sectionVisibility.thisMonthEnded && <MyDatagrid fullHeight checkField={false}
                                            summeryFields={['fullBasicSalary', 'basicSalary', 'cash']}
                                            data={variance.thisMonthEndEmps.map((e, index) => ({...e, sn: index + 1}))}
                                            ids={variance.thisMonthEndEmps.map((e, index) => index)} currentSort={sort}
                                            setSort={handelSort}>
                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <DateField label={"Ended On"} source={"employee.contractEndDate"}/>
                                    <MultiCurrencyField label={"Net Pay"} source={"cash"}/>
                                </MyDatagrid>}
                            </Grid>
                        </Grid>
                        {/* Salary Adjustment */}
                        <Grid container spacing={10}>
                            <div className={`page-break${sectionVisibility.salaryAdjustment ? '' : ' no-print'}`}></div>
                            <Grid item>
                                <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.salaryAdjustment ? '' : 'no-print'}>
                                    <Grid item className="no-print">
                                        <IconButton size="small" onClick={() => toggleSection('salaryAdjustment')}>
                                            {sectionVisibility.salaryAdjustment ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h5">Salary Adjustment</Typography>
                                    </Grid>
                                </Grid>
                                {sectionVisibility.salaryAdjustment && <MyDatagrid fullHeight checkField={false}
                                            summeryFields={['fullBasicSalary', 'diffFullBasic']}
                                            data={variance.salaryChange.filter(e => e.diffFullBasic !== 0).map((e, index) => ({
                                                ...e,
                                                sn: index + 1
                                            }))}
                                            ids={variance.salaryChange.filter(e => e.diffFullBasic !== 0).map((e, index) => index)}
                                            currentSort={sort} setSort={handelSort}>
                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <MultiCurrencyField label={"Prev Salary"} source={"prevPayroll.fullBasicSalary"}/>
                                    <MultiCurrencyField label={"fullBasicSalary"} source={"fullBasicSalary"}/>
                                    <MultiCurrencyField label={"Basic Salary Change"} source={"diffFullBasic"}/>
                                </MyDatagrid>}
                            </Grid>
                        </Grid>
                        {/* Overtime */}
                        <div className={`page-break${sectionVisibility.overtime ? '' : ' no-print'}`}></div>
                        <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.overtime ? '' : 'no-print'}>
                            <Grid item className="no-print">
                                <IconButton size="small" onClick={() => toggleSection('overtime')}>
                                    {sectionVisibility.overtime ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5">Overtime</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={10}>

                            <Grid item>
                                {sectionVisibility.overtime && <>
                                    <Grid container alignItems="center" spacing={1} style={{marginBottom: 4}} className="no-print">
                                        <Grid item>
                                            <IconButton size="small" onClick={() => setShowPrevOvertime(prev => !prev)}>
                                                {showPrevOvertime ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                            </IconButton>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body2" style={{opacity: 0.7}}>Show Previous Month</Typography>
                                        </Grid>
                                    </Grid>
                                    <MyDatagrid fullHeight checkField={false} summeryFields={['overtimeTotal', ...(showPrevOvertime ? ['diffOT', 'prevPayroll.overtimeTotal'] : [])]}
                                                data={currentOvertimes} ids={currentOvertimes.map((e, index) => index)}
                                                currentSort={{field: 'overtimeTotal', order: 'DESC'}} setSort={handelSort}>

                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <MultiCurrencyField source={"basicSalary"}/>
                                    <NumberField source="otNormal"/>
                                    <NumberField source="otNight"/>
                                    <NumberField source="otRest"/>
                                    <NumberField source="otHollyDay"/>
                                    <NumberField source="otOther"/>
                                    <MultiCurrencyField label={"Overtime"} source={"overtimeTotal"}/>
                                    {showPrevOvertime && <MultiCurrencyField label={"Prev Overtime"} source={"prevPayroll.overtimeTotal"}/>}
                                    {showPrevOvertime && <MultiCurrencyField label={"Overtime Change"} source={"diffOT"}/>}
                                </MyDatagrid>
                                </>}
                            </Grid>
                        </Grid>
                        {/* Service Charge Details */}
                        {filteredPayrolls && filteredPayrolls.some(p => p.serviceCharge || p.serviceChargeDeduction) && <>
                        <div className={`page-break${sectionVisibility.serviceChargeDetails ? '' : ' no-print'}`}></div>
                        <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.serviceChargeDetails ? '' : 'no-print'}>
                            <Grid item className="no-print">
                                <IconButton size="small" onClick={() => toggleSection('serviceChargeDetails')}>
                                    {sectionVisibility.serviceChargeDetails ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5">Service Charge Details</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={10}>
                            <Grid item>
                                {sectionVisibility.serviceChargeDetails && <MyDatagrid fullHeight checkField={false}
                                            summeryFields={['serviceDays', 'serviceCharge']}
                                            data={serviceChargeDetails}
                                            ids={serviceChargeDetails.map((e, index) => index)}
                                            currentSort={serviceChargeSort}
                                            setSort={handleServiceChargeSort}>
                                    <NumberField source="sn"/>
                                    <TextField source="fullName"/>
                                    <NumberField source="serviceDays"/>
                                    <MultiCurrencyField label={"Service Charge"} source={"serviceCharge"}/>
                                    <FunctionField label="Remark" render={record => {
                                        if (!record.serviceDays || record.serviceDays >= moment(payrollRun.periodEnd).daysInMonth()) return '';
                                        const reasons = [];
                                        if (record.employee && record.employee.startDate && moment(record.employee.startDate).isAfter(moment(payrollRun.periodStart))) {
                                            reasons.push('Started: ' + moment(record.employee.startDate).format('MMM DD'));
                                        }
                                        if (record.employee && record.employee.contractEndDate && moment(record.employee.contractEndDate).isBefore(moment(payrollRun.periodEnd))) {
                                            reasons.push('Ended: ' + moment(record.employee.contractEndDate).format('MMM DD'));
                                        }
                                        if (record.absentDays > 0) {
                                            reasons.push('Absent: ' + record.absentDays + 'd');
                                        }
                                        if (record.leaveDays > 0) {
                                            reasons.push('Leave: ' + record.leaveDays + 'd');
                                        }
                                        const deductedDays = moment(payrollRun.periodEnd).daysInMonth() - record.serviceDays;
                                        return reasons.length > 0 ? reasons.join(', ') : deductedDays + ' Service Days Deducted';
                                    }}/>
                                </MyDatagrid>}
                            </Grid>
                        </Grid>
                        </>}
                        {/* Allowance Change */}
                        <div className={`page-break${sectionVisibility.allowanceChange ? '' : ' no-print'}`}></div>
                        <Grid container spacing={10}>
                                <Grid item>
                                    <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.allowanceChange ? '' : 'no-print'}>
                                        <Grid item className="no-print">
                                            <IconButton size="small" onClick={() => toggleSection('allowanceChange')}>
                                                {sectionVisibility.allowanceChange ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                            </IconButton>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h5">Allowance Change</Typography>
                                        </Grid>
                                    </Grid>
                                    {sectionVisibility.allowanceChange && <MyDatagrid fullHeight checkField={false}
                                                summeryFields={['overtimeTotal', 'diffAdditionalEarnings', 'prevPayroll.overtimeTotal']}
                                                data={variance.salaryChange.filter(e => e.diffAdditionalEarnings !== 0).map((e, index) => ({
                                                    ...e,
                                                    sn: index + 1
                                                }))}
                                                ids={variance.salaryChange.filter(e => e.diffAdditionalEarnings !== 0).map((e, index) => index)}
                                                currentSort={sort} setSort={handelSort}>
                                        <NumberField source="sn"/>
                                        <TextField source="fullName"/>
                                        <MultiCurrencyField label={"Prev Allowance"}
                                                            source={"prevPayroll.additionalFixedEarnings"}/>
                                        <MultiCurrencyField label={"Allowance"} source={"additionalFixedEarnings"}/>
                                        <MultiCurrencyField label={"Allowance Change"}
                                                            source={"diffAdditionalEarnings"}/>
                                    </MyDatagrid>}
                                </Grid>
                            </Grid>
                            {/* Absent Deduction */}
                            <div className={`page-break${sectionVisibility.absentDeduction ? '' : ' no-print'}`}></div>
                            <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.absentDeduction ? '' : 'no-print'}>
                                <Grid item className="no-print">
                                    <IconButton size="small" onClick={() => toggleSection('absentDeduction')}>
                                        {sectionVisibility.absentDeduction ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                    </IconButton>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h5">Absent Deduction</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={10}>

                                <Grid item>
                                    {sectionVisibility.absentDeduction && <>
                                        <Grid container alignItems="center" spacing={1} style={{marginBottom: 4}} className="no-print">
                                            <Grid item>
                                                <IconButton size="small" onClick={() => setShowPrevAbsentDeductions(prev => !prev)}>
                                                    {showPrevAbsentDeductions ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                                </IconButton>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="body2" style={{opacity: 0.7}}>Show Previous Month</Typography>
                                            </Grid>
                                        </Grid>
                                        <MyDatagrid fullHeight checkField={false} summeryFields={['basicAbsentDeduction', ...(showPrevAbsentDeductions ? ['prevPayroll.basicAbsentDeduction'] : [])]}
                                                data={absentDeductions} ids={absentDeductions.map((i, index) => index)}
                                                currentSort={{field: 'basicAbsentDeduction', order: 'DESC'}}
                                                setSort={handelSort}>
                                        <NumberField source="sn"/>
                                        <TextField source="fullName"/>
                                        <MultiCurrencyField label={"Full Basic Salary"} source={"fullBasicSalary"}/>
                                        <NumberField source="absentDays"/>
                                        <FunctionField style={{width: '100px'}} label="Penalty Hours/Expected Hours"
                                                       render={record => <span><FormattedNumber
                                                           maximumFractionDigits={1}
                                                           value={record.monthlyHours - record.hoursWorked}/>/<FormattedNumber
                                                           maximumFractionDigits={1}
                                                           value={record.monthlyHours}/></span>}/>
                                        {showPrevAbsentDeductions && <MultiCurrencyField label={"Prev Absent Deduction"}
                                                            source={"prevPayroll.basicAbsentDeduction"}/>}
                                        <MultiCurrencyField label={"Absent Deduction"} source={"basicAbsentDeduction"}/>
                                    </MyDatagrid>
                                    </>}
                                </Grid>
                            </Grid>
                            {/* Prorated Salary Change */}
                            <div className={`page-break${sectionVisibility.proratedSalaryChange ? '' : ' no-print'}`}></div>
                            <Grid container alignItems="center" spacing={1} style={{marginBottom: 4, marginTop: 8}} className={sectionVisibility.proratedSalaryChange ? '' : 'no-print'}>
                                <Grid item className="no-print">
                                    <IconButton size="small" onClick={() => toggleSection('proratedSalaryChange')}>
                                        {sectionVisibility.proratedSalaryChange ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                    </IconButton>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h5">Prorated Salary Change</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={10}>
                                <Grid item>
                                    {sectionVisibility.proratedSalaryChange && <MyDatagrid fullHeight checkField={false}
                                                summeryFields={['basicSalary', 'diffBasic']}
                                                data={variance.salaryChange.filter(e => e.diffBasic !== 0).map((e, index) => ({
                                                    ...e,
                                                    sn: index + 1
                                                }))}
                                                ids={variance.salaryChange.filter(e => e.diffBasic !== 0).map((e, index) => index)}
                                                currentSort={sort} setSort={handelSort}>
                                        <NumberField source="sn"/>
                                        <TextField source="fullName"/>
                                        <MultiCurrencyField label={"Prev Salary"} source={"prevPayroll.basicSalary"}/>
                                        <MultiCurrencyField label={"basicSalary"} source={"basicSalary"}/>
                                        <MultiCurrencyField label={"Basic Salary Change"} source={"diffBasic"}/>
                                    </MyDatagrid>}
                                </Grid>

                            </Grid>


                    </div>}
                </div>}
            </div>
        </div>
);
};

export default PayrollSummeryReport;
